import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import ChevronRightGreen from "assets/svgs/ChevronRightGreen";
import ChevronLeftBlackBg from "assets/svgs/ChevronLeftBlackBg";
import clsx from "clsx";
import { useWindowResize } from "utils/hooks";
import { useRouter } from "next/router";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";

export type ExploreByOtherCitiesModule = {
	type: string;
};
const ExploreJobsInOthercity = ({ data }) => {
	const scrollCitiesRef = useRef();
	const [isMobileView] = useWindowResize();
	const router = useRouter();

	const { resetSearch, setCitySearchObject } = useJobFeedStore();

	useEffect(() => {
		scrollToDefaultPosition();
	}, [data]);

	const [scrollIndicator, setScrollIndicator] = useState(0);
	const handleScrollCities = (towards: string) => {
		if (scrollCitiesRef.current) {
			scrollCitiesRef.current.scrollBy({
				left: towards === "left" ? -100 : +100,
				behavior: "smooth",
			});
		}
	};

	const handleCityClick = (city) => {
		resetSearch();
		scrollToDefaultPosition();
		setCitySearchObject(city);
		updateQueryParams({
			location_id: city.id,
			location_identifier: city.identifier,
			location_type: city.type,
			location_name: city.name,
		});
	};

	const scrollToDefaultPosition = () => {
		if (scrollCitiesRef.current) {
			scrollCitiesRef.current.scroll({ left: 0, behaviour: "smooth" });
		}
	};

	const updateQueryParams = (newParams) => {
		const { pathname, query } = router;
		const updatedQuery = { ...query, ...newParams };

		router.push(
			{
				pathname,
				query: updatedQuery,
			},
			undefined
		);
	};

	const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
		const { scrollLeft, scrollWidth, clientWidth } = e.currentTarget;
		const totalScrollableWidth = scrollWidth - clientWidth;
		const leftOffset = (scrollLeft / totalScrollableWidth) * 100;
		setScrollIndicator(leftOffset);
	};
	if (!data?.title) return <></>;
	return (
		<div className="relative mt-[16px] items-center rounded-[12px] border-solid border-[#D3BEF1] bg-[#F1EAFA] p-[16px] md:flex md:h-[204px] md:max-w-[1040px] md:border-[1px] md:bg-explore-other-city-gradient md:p-0">
			<div className="mb-[16px] w-[335px] md:m-[16px] md:h-[76px] md:w-[134px]">
				<p className="m-0 block text-[20px] font-[700] text-[#3F1973] md:w-[134px]">
					{data?.title}
				</p>
				<p className="m-0 mt-[5px] block p-0 text-[12px] font-[400] leading-[16px] text-[#827485]">
					{data?.sub_title}
				</p>
			</div>
			{scrollIndicator > 0 && (
				<ChevronLeftBlackBg
					className="absolute left-[10rem] top-[50%] z-[1] hidden translate-y-[-50%] cursor-pointer md:block"
					onClick={() => {
						handleScrollCities("left");
					}}
				/>
			)}
			{scrollIndicator < 100 && (
				<ChevronLeftBlackBg
					onClick={() => {
						handleScrollCities("right");
					}}
					className="absolute right-2 top-[50%] z-[1] hidden translate-y-[-50%] rotate-180 cursor-pointer md:block"
				/>
			)}
			<div
				ref={scrollCitiesRef}
				className={clsx(
					"relative flex h-[172px] w-[100%] flex-1 shrink-0 grow items-stretch overflow-scroll md:mt-0 md:w-[347px] md:p-0",
					{
						scrollbarHide: !isMobileView,
						"scrollbar-thin scroll-mx-2.5 scroll-my-4 overflow-y-hidden overflow-x-scroll":
							isMobileView,
					}
				)}
				onScroll={handleScroll}
			>
				<div className="flex items-end">
					<div className="absolute flex">
						{data?.children?.map((city) => (
							// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
							<div
								onClick={() => {
									handleCityClick(city?.location);
								}}
								key={city.location.identifier}
								className="mr-[8px] flex h-[172px] w-[144px] cursor-pointer flex-col items-center rounded-[8px] bg-[#FFFFFF] py-[12px]"
							>
								<span className="w-[128px] overflow-hidden truncate whitespace-nowrap pb-[4px] text-center text-[14px]  font-[600] leading-[20px] text-[#190A28]">
									{city.location.name}
								</span>
								<span className="text-[12px] font-[400] leading-[16px] text-[#8C8594]">
									{city.job_count} jobs
								</span>
								<span className="p-[12px]">
									<Image
										loading="lazy"
										src={city.icon_url}
										className="h-[64px] w-[64px] rounded-full bg-[#F4F2F6]"
										alt="city"
										width={64}
										height={64}
									/>
								</span>
								<div className="h-[24px] w-[128px]">
									<button
										className="m-auto block"
										type="button"
										onClick={() => {}}
									>
										<div className="flex">
											<span className="mr-[4px] text-[12px] font-[600] leading-[16px] text-[#1F8268]">
												View jobs
											</span>
											<div>
												<ChevronRightGreen />
											</div>
										</div>
									</button>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="relative top-[16px] m-auto mb-[16px] block h-[2px] w-[48px] bg-[#D1CED4] md:hidden">
				<div
					className="absolute bottom-0 left-0 top-[50%] h-[4px] w-[12px] translate-y-[-50%] rounded-[8px] bg-[#342852]"
					style={{ marginLeft: `${scrollIndicator}%` }}
				/>
			</div>
		</div>
	);
};

export default ExploreJobsInOthercity;
